define('mixins/ValidationMixin',['require','underscore','lib/Podio.UI.Tooltips','translate'],function(require) {

  var _ = require('underscore');
  var Tooltips = require('lib/Podio.UI.Tooltips');
  var t = require('translate');

  return {
    specialSettings: ['label', 'msg'],

    validators: {
      required: function(val, setting) {
        return !setting || !_.isEmpty(String(val));
      },
      maxlength: function(val, setting) {
        if (!val) {
          return true;
        }
        return String(val).length <= setting;
      },
      digits: function(val, setting) {
        if (!val) {
          return true;
        }

        return !setting || /^\d+$/.test(String(val));
      },
      min: function(val, setting) {
        if (!val) {
          return true;
        }

        return !setting || parseFloat(val, 10) >= setting;
      },
      max: function(val, setting) {
        if (!val) {
          return true;
        }

        return !setting || parseFloat(val, 10) <= setting;
      },
    },

    validationMessages: {
      required: t('{0} is required #validation'),
      maxlength: t('{0} cannot be longer than {1} characters #validation'),
      digits: t('Please enter only digits in {0} #validation'),
      min: t('Please enter a value greater than or equal to {1} in {0} #validation'),
      max: t('Please enter a value less than or equal to {1} in {0} #validation')
    },

    adaptors: {
      integer: function(val) {
        if (!val) {
          return val;
        }

        if (/^\d+$/.test(String(val))) {
          var converted = parseInt(Number(val), 10);
          return _.isNaN(converted) ? val : converted;
        } else {
          return val;
        }
      }
    },

    getInitialState: function() {
      return {
        validationErrors: {}
      };
    },

    validateClick: function(validatedCallback, failedCallback) {
      var self = this;

      return function() {
        if (self.validateAll()) {
          validatedCallback();
        } else {
          if (_.isFunction(failedCallback)) {
            failedCallback();
          }
        }
      };
    },

    stateSetter: function(key, newValue, callback) {
      var obj = {};

      obj[key] = newValue;

      this.setState(obj, callback);
    },

    stateValue: function(state) {
      return this.state[state];
    },

    validatedLinkState: function(state) {
      return {
        value: this.state[state],
        requestChange: this.proxyAndValidateSetter(this.stateSetter.curry(state), state)
      };
    },

    // If you use this to tie in your own requestChange handler, remember to callback the validation function
    // given as the third argument to the handler.
    // See ContractTunerComponent for an example of this.
    validatedValueLink: function(state, valueLink) {
      valueLink.requestChange = this.proxyAndValidateSetter(valueLink.requestChange, state);

      return valueLink;
    },

    proxyAndValidateSetter: function(setterFunc, state) {
      var self = this;

      return function() {
        var args = _.toArray(arguments);

        args.push(self.adaptAndValidateAttr.curry(state));

        setterFunc.apply(this, args);
      };
    },

    validateAll: function() {
      return _.all(this.validations, function(config, state) {
        return this.validateAttr(state);
      }.bind(this));
    },

    adaptAndValidateAttr: function(state) {
      this.adaptAttribute(state);
      return this.validateAttr(state);
    },

    validateAttr: function(state) {
      var label = this.validations[state].label;
      var msg = this.validations[state].msg;
      var result = _.all(this.validations[state], function(ruleSetting, rule) {
        if (!_.include(this.specialSettings, rule)) {
          return this.validateRule(rule, state, {
            ruleSetting: ruleSetting,
            label: label,
            msg: msg
          });
        } else {
          return true;
        }
      }.bind(this));

      return result;
    },

    validateRule: function(rule, state, options) {
      var result = this.validators[rule](this.state[state], options.ruleSetting);

      this.updateErrorList(state, rule, result, options);

      return result;
    },

    adaptAttribute: function(state) {
      if (this.adaptations) {
        var targetType = this.adaptations[state];
        if (targetType) {
          var val = this.state[state];
          var converted = this.adaptors[targetType](val);
          if (converted !== val) {
            var adaptedState = {};
            adaptedState[state] = converted;
            this.setState(adaptedState);
          }
        }
      }
    },

    getErrorMessage: function(rule, options) {
      if (_.has(this.validationMessages, rule)) {
        return this.validationMessages[rule].format(options.label, options.ruleSetting);
      } else if (_.isUndefined(options.msg)) {
        throw new Error('You need to define a msg property on the validation containing an error message');
      } else {
        return options.msg;
      }
    },

    updateErrorList: function(state, rule, result, options) {
      var validationErrors = this.state.validationErrors;
      var errorMessage = this.getErrorMessage(rule, options);
      var rulesList;
      var ruleIndex;

      if (_.isUndefined(validationErrors[state])) {
        validationErrors[state] = [];
      }

      rulesList = validationErrors[state];
      ruleIndex = rulesList.indexOf(errorMessage);

      if (result) {
        if (ruleIndex > -1) {
          rulesList.splice(ruleIndex, 1);
          this.setState({ validationErrors: validationErrors });
          this.hideTooltips();
        }
      } else {
        if (ruleIndex === -1) {
          rulesList.push(errorMessage);
          this.setState({ validationErrors: validationErrors });
        }
      }
    },

    getValidationErrors: function(state) {
      var errors = this.state.validationErrors[state];

      if (_.isUndefined(errors) || errors.length === 0) {
        return '';
      } else {
        return errors.join(',');
      }
    },

    hideTooltips: function() {
      Tooltips.hideAll();
    }
  };

});

